import { render, staticRenderFns } from "./shipment-options.vue?vue&type=template&id=62301eb5&"
import script from "./shipment-options.vue?vue&type=script&lang=js&"
export * from "./shipment-options.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports